export { useOrganizations } from '@clerk/shared/react';
